import { Heading } from "components/Theme/heading";
import type { GatewayAssetOut } from "kubb";
import type React from "react";
import DisplayIfUserType from "../../../../components/utils/DisplayIfUserType/DisplayIfUserType";
import GatewayConfigurationDropdown from "./GatewayConfigurationDropdown";
import GatewayConnectionDisplay from "./GatewayConnectionDisplay";
import GatewaySettingForm from "./GatewaySettingForm";

export default function GatewayConfigurationTab(props: {
  gateway: GatewayAssetOut;
  refresh?: () => any;
}): React.ReactElement {
  const { gateway } = props;
  return (
    <>
      <DisplayIfUserType userTypes={"superadmin"}>
        <div>
          <Heading>Gateway Settings</Heading>
          <GatewaySettingForm gateway={gateway} refresh={props.refresh} />
        </div>
      </DisplayIfUserType>
      <div>
        <GatewayConnectionDisplay gateway={gateway} />
      </div>

      <DisplayIfUserType userTypes={"admin"}>
        <GatewayConfigurationDropdown gateway={gateway} />
      </DisplayIfUserType>
    </>
  );
}
